import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ArgResolver, Column, ValueTransformer } from '../smart-table.service';
import { getValueByPath, getValueByPaths } from '../../util/helpers';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'ws-smart-cell',
	templateUrl: './smart-cell.component.html',
	styleUrls: ['./smart-cell.component.scss'],
})
export class SmartCellComponent implements OnInit, OnChanges {
	@Input() column!: Column;
	@Input() entry!: Record<string, any>;
	@Input() context?: Record<string, any>;

	public transformedValue: any;

	constructor(public domSanitizer: DomSanitizer) {}

	public get value() {
		return getValueByPaths(this.entry, this.column.field);
	}

	ngOnInit() {}

	ngOnChanges() {
		if (this.column?.valueTransformer) {
			this.applyTransformers(this.column.valueTransformer).then((val) => (this.transformedValue = val));
		} else {
			this.transformedValue = this.value;
		}
	}

	private get mergedContext(): Record<string, any> {
		return { ...this.context, _entry: this.entry };
	}

	/**
	 * Recursively applies a chain of transformers to process cell values.
	 * Supports both synchronous and asynchronous transform() methods.
	 *
	 * @param transformer - The transformer configuration to apply
	 * @returns The transformed value, which could be any type depending on the transformer chain
	 */
	private async applyTransformers(transformer: ValueTransformer | ArgResolver): Promise<any> {
		if (!transformer) {
			return '';
		}

		if (transformer.argResolver) {
			const resolvedArgs = await this.applyTransformers(transformer.argResolver);
			transformer.args = {
				...transformer.args,
				...resolvedArgs,
			};
		}

		let inputValue: any;
		if (transformer.dependentTransformer) {
			inputValue = await this.applyTransformers(transformer.dependentTransformer);
		} else {
			inputValue = getValueByPaths(this.entry, transformer.field!);
		}

		let result = await transformer.transformer!.transform(inputValue, transformer.args, this.mergedContext);

		if ((transformer as ArgResolver).argsWriteTo) {
			result = { [(transformer as ArgResolver).argsWriteTo]: result };
		}

		return result;
	}
}
